"use client";

import Link from "next/link";
import { HiArrowRight } from "@/components/icons";

export interface ToolCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  href: string;
  className?: string;
  badge?: string;
}

export default function ToolCard({
  title,
  description,
  icon,
  href,
  className = "",
  badge,
}: ToolCardProps) {
  return (
    <Link
      href={href}
      className={`group rounded-2xl border border-border/50 p-6 hover:border-primary/30 hover:bg-muted/20 transition-all flex flex-col h-full ${className}`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="rounded-full bg-primary/10 p-3 w-12 h-12 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
          {icon}
        </div>
        {badge && (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-primary/10 text-primary">
            {badge}
          </span>
        )}
      </div>
      <h3 className="text-lg font-bold group-hover:text-primary transition-colors mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground leading-relaxed mb-4 flex-1">{description}</p>
      <span className="inline-flex items-center gap-1 text-sm font-medium text-primary">
        Launch tool <HiArrowRight className="w-4 h-4" />
      </span>
    </Link>
  );
}
